<template>
  <div class="carousel-container" role="region" aria-label="Training Programs">
    <div v-if="pageIsLoading" class="carousel-loading-skeleton d-flex align-items-center justify-content-center">
      <div class="spinner-border text-brand" role="status">
        <span class="visually-hidden">جاري التحميل...</span>
      </div>
    </div>
    <b-carousel
      v-else-if="data && data.length > 0"
      fade
      id="hero-banner-carousel"
      v-model="slide"
      :interval="5000"
      controls
      indicators
      background="#f8f9fa"
      img-width="1024"
      img-height="480"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        v-for="item in data"
        :key="item.id || item.image"
        :img-src="item.image || item.photo || require('@/assets/images/logo.png')"
        class="carousel-item-image"
      ></b-carousel-slide>
    </b-carousel>
    <div v-else class="carousel-fallback d-flex align-items-center justify-content-center">
      <img src="@/assets/images/logo.png" alt="Baron Academy" class="fallback-logo" />
    </div>
  </div>
</template>

<script>
import { sendRequest } from '../../utils/RequestHelper';

export default {
  name: 'LandingpageCarousel',
  data() {
    return {
      slide: 0,
      sliding: null,
      data: [],
      pageIsLoading: true
    }
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    loadData() {
      this.pageIsLoading = true;
      var successCallback = (data) => {
        this.data = Array.isArray(data) ? data : [];
        this.pageIsLoading = false;
      };
      var errorCallback = () => {
        this.data = [];
        this.pageIsLoading = false;
      };
      sendRequest('get', 'configuration/sliders/', false, {}, successCallback, errorCallback);
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style scoped>
.carousel-container {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  background-color: #f8f9fa;
  min-height: 280px;
  position: relative;
}

.carousel-loading-skeleton,
.carousel-fallback {
  height: 380px;
  width: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.fallback-logo {
  max-height: 120px;
  object-fit: contain;
  opacity: 0.85;
  filter: drop-shadow(0 6px 14px rgba(11, 61, 56, 0.15));
}

::v-deep .carousel-item img {
  width: 100%;
  height: clamp(260px, 45vh, 500px);
  object-fit: cover;
  object-position: center;
  border-radius: 16px;
}

/* Enhanced Control Styling & RTL Support */
::v-deep .carousel-control-prev,
::v-deep .carousel-control-next {
  width: 8%;
  opacity: 0.85;
  transition: opacity 0.3s ease;
}

::v-deep .carousel-control-prev:hover,
::v-deep .carousel-control-next:hover {
  opacity: 1;
}

::v-deep .carousel-control-prev-icon,
::v-deep .carousel-control-next-icon {
  width: 44px;
  height: 44px;
  background-color: rgba(20, 99, 86, 0.85);
  border-radius: 50%;
  background-size: 50% 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background-color 0.2s ease;
}

::v-deep .carousel-control-prev-icon:hover,
::v-deep .carousel-control-next-icon:hover {
  background-color: var(--brand-teal);
  transform: scale(1.1);
}

::v-deep .carousel-indicators {
  margin-bottom: 1rem;
}

::v-deep .carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 5px;
  background-color: rgba(255, 255, 255, 0.7);
  border: 2px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

::v-deep .carousel-indicators .active {
  background-color: var(--brand-teal);
  width: 26px;
  border-radius: 6px;
}
</style>